import React, { FC, useState } from 'react';

import { QueryTable } from '@app/components/common/table';
import { Warehouse } from '@app/api/models/distributor';
import { useApi, useFetchData } from '@app/hooks';

import { useColumns } from './columns';
import { EditWarehouse } from './edit';

export const WarehousesTable: FC = () => {
  const api = useApi();
  const [fetchData] = useFetchData<Warehouse>({    
    method: () => api.distributors.getWarehouses().then((res) => ({ 
      data: {
        data: res.data, 
        total: res.data?.length || 0
      },
      message: res.message,
      code: res.code,
    })),
  });
  const [editOpen, setEditOpen] = useState(false);
  const [operatedItem, setOperatedItem] = useState<Warehouse>();

  const columns = useColumns({
    onEdit: (item) => {
      setOperatedItem(item);
      setEditOpen(true);
    },
  });

  return (
    <QueryTable
      title="Склады"
      columns={columns}
      fetchData={fetchData}
      onCreateClick={() => {
        setOperatedItem(undefined);
        setEditOpen(true);
      }}
      noPagination
    >
      <EditWarehouse
        open={editOpen}
        setOpen={() => setEditOpen(false)}
        initial={operatedItem}
      />
    </QueryTable>
  );
};
